import { render, staticRenderFns } from "./TypeOfBets.vue?vue&type=template&id=3a4eaff2&scoped=true&"
var script = {}
import style0 from "./TypeOfBets.vue?vue&type=style&index=0&id=3a4eaff2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4eaff2",
  null
  
)

export default component.exports